import { Button, Col, Input, Layout, Row, Table, Typography, notification } from "antd";
import { AutoCompleteCompany, FormatDate, Header } from "components";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal } from 'antd';
import { issueVirtualCard, loadHistoryCards } from "services/card-service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getCompany } from "services/company-service";
import { getAllEmployees } from "services/employee-service";
import { Tooltip } from 'antd';
const { Text } = Typography;


const { Footer, Content } = Layout;
const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer
});

const VirtualCardScreen = (props) => {

    const { login } = props;
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [company, setCompany] = useState(null);
    const [cardHistoryShow, setCardHistoryShow] = useState(false);
    const [cards, setCards] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);
    const CARD_TYPE_VIRTUAL = 'virtual';
    const [searchValue, setSearchValue] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [filterEmployees, setFilterEmployees] = useState([]);


    const load = async (filter = '') => {
        setLoading(true);
        let usersResponse;

        if (login.company.master) {
            usersResponse = await getAllEmployees({ company: searchParams.get("company") });
            const responseCompany = await getCompany(searchParams.get("company"));
            setUsers(usersResponse);
            setCompany(responseCompany);


        } else {
            usersResponse = await getAllEmployees({ company: login.company.id });
            setUsers(usersResponse);
            setCompany(login.company);
        }

        setLoading(false);
    }

    const onFilter = (value) => {
        const lowercasedValue = value.toLowerCase();
        const filteredEmployees = users.filter(employee => {
            return employee.name.toLowerCase().includes(lowercasedValue) ||
                employee.email.toLowerCase().includes(lowercasedValue) ||
                employee.cpf.replace(/[^\d]/g, '').includes(value)
        });

        setFilterEmployees(filteredEmployees);
    };

    useEffect(() => {
        load();
    }, []);


    const openHistoryCards = async (userId) => {
        setCards([]);
        setLoadingCards(true);
        setCardHistoryShow(true);
        try {
            let res = await loadHistoryCards(userId, CARD_TYPE_VIRTUAL);
            setCards(res);
        } catch (e) {
            console.log(e);
        } finally {
            setLoadingCards(false);
        }
    };

    const onIssueVirtualCard = async () => {
        setLoading(true);
        const issuanceList = [];
        selectedRowKeys.forEach(rowID => {
            issuanceList.push({
                id: rowID,
                singleUse: false,
                issuedBy: 'admin',
            });
        });

        await issueVirtualCard(issuanceList)
            .then((response) => {
                if (response.info) {
                    notification.warning({
                        message: response.info
                    });
                } else {
                    notification.success({
                        message: 'Emissão concluída!'
                    });
                }
                navigate("/card");
            })
            .catch(() => notification.error({
                message: 'Ocorreu um erro no processamento de emissão!'
            }));
        setLoading(false);

    }

    const onChangeCompany = (companyId) => {
        searchParams.set("company", `${companyId}`);
        load();
    }

    return (
        <Layout className="alymente-layout">

            <Header
                title={'Emissão de cartões virtuais'}
                subtitle="Selecione os usuários para os quais deseja emitir um cartão virtual."
                middle={
                    login.company.master ? <AutoCompleteCompany value={company} onChange={onChangeCompany} /> : undefined
                }
            />

            <Content
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
            >
                <Row>
                    <Table
                        rowKey={'id'}
                        scroll={{ y: 450 }}
                        loading={loading}
                        dataSource={searchValue ? filterEmployees : users}
                        pagination={false}
                        rowSelection={{
                            selectedRowKeys: selectedRowKeys,
                            onChange: (items) => {
                                if (filterEmployees.length > 0) {
                                    var newItems = [...selectedRowKeys];
                                    for (let i of filterEmployees) {
                                        if (items.filter(f => f === i.id).length > 0 && selectedRowKeys.filter(s => s === i.id).length === 0)
                                            newItems.push(i.id);
                                        else if (items.filter(f => f === i.id).length === 0 && selectedRowKeys.filter(s => s === i.id).length > 0) {
                                            newItems.splice(newItems.findIndex(f => f === i.id), 1);
                                        }
                                    }
                                    setSelectedRowKeys(newItems);
                                } else {
                                    setSelectedRowKeys(items);
                                }
                            },
                            getCheckboxProps: (row) => ({
                                disabled: !row.accountStatus,
                            })
                        }}
                        bordered
                        title={() => (
                            <Row>
                                <Col xs={12}>
                                    <Typography.Text>Selecionados: {selectedRowKeys.length}/{users.length}</Typography.Text>
                                </Col>
                                <Col xs={6} style={{ marginLeft: 'auto' }}>
                                    <Input
                                        allowClear
                                        value={searchValue}
                                        onChange={e => {
                                            setSearchValue(e.target.value);
                                            onFilter(e.target.value);
                                        }}
                                        placeholder="Pesquise por nome, e-mail ou cpf"
                                    />
                                </Col>
                            </Row>
                        )}
                    >
                        <Table.Column
                            title="Nome"
                            dataIndex={"name"}
                            key={"name"}
                            render={(value, row) => {
                                if (!row.accountStatus) {
                                    return <Tooltip placement="bottom" title={row.validation || "Dados pendentes de validação."}>
                                        <Text mark>{value}</Text>
                                    </Tooltip>
                                }
                                return value;
                            }}
                        > </Table.Column>
                        <Table.Column title="Email" dataIndex={"email"} key={"email"}> </Table.Column>
                        <Table.Column title="CPF" dataIndex={"cpf"} key={"cpf"}> </Table.Column>
                        <Table.Column
                            width={100}
                            title="Cartões"
                            render={(value, row) => (
                                <Button
                                    size="small"
                                    type={"link"}
                                    loading={login.isProcessing}
                                    onClick={() => openHistoryCards(value.id)}
                                >
                                    Ver
                                </Button>
                            )}
                        > </Table.Column>
                    </Table>
                </Row>

            </Content>

            <Footer style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
            }}>
                <Button
                    className="btn-save"
                    type="primary"
                    loading={loading}
                    onClick={() => navigate(`/card`)}>
                    Voltar
                </Button>
                <Button
                    disabled={selectedRowKeys.length < 1 || loading}
                    type="primary"
                    className="btn-save"
                    onClick={() => onIssueVirtualCard()}
                >
                    Emitir
                </Button>
            </Footer>

            <Modal
                open={cardHistoryShow}
                title="Cartões Virtuais do Participante"
                onCancel={() => {
                    setCardHistoryShow(false);
                    setCards([]);
                }}
                onOk={() => {
                    setCardHistoryShow(false);
                    setCards([]);
                }}
                width={600}
            >
                <Table
                    scroll={{ y: 400 }}
                    dataSource={cards}
                    loading={loadingCards}
                    pagination={false}
                    bordered
                >
                    <Table.Column
                        title="Número do Cartão"
                        dataIndex="cardNumber"
                        key="cardNumber"
                    />
                    <Table.Column
                        align="center"
                        width={150}
                        title="Atualizado em"
                        dataIndex="updatedAt"
                        key="updatedAt"
                        render={(value) => <FormatDate value={value} />}
                    />
                    <Table.Column
                        align="center"
                        width={150}
                        title="Status"
                        dataIndex="active"
                        key="active"
                        render={(value) => (value ? "Ativo" : "Bloqueado")}
                    />
                </Table>
            </Modal>

        </Layout>
    );

}

export default connect(mapStateToProps, {})(VirtualCardScreen);
